import { TRequestBuilder, TWardrobeItem, TPost, TFilteredRequest, TArticle, TArticleEdit } from '@typings'
import { upDataTransformer } from '../transformers'

export const getPosts: TRequestBuilder<TFilteredRequest & Partial<TPost>> = (params) => ({
	method: 'get',
	url: '/posts',
	params,
})
